
const Q = require('q');
const _ = require('lodash');


function Config (options) {
	if (typeof options === 'function') {
		options = {
			getter: options,
		};
	}
	options = _.defaults(options || {}, {
		getter: null,
		cacheGetter: true,
		subsections: {},
	});
	if (typeof options.subsections === 'object') {
		_.extend(this, options.subsections);
	}
	this._options = options;
}

Object.assign(Config.prototype, {
	get: function () {
		const self = this;
		if (typeof self._options.getter === 'function') {
			if ('_cachedGetterValue' in self) {
				return self._cachedGetterValue;
			}
			const promise = Q(self._options.getter());
			if (self._options.cacheGetter) {
				self._cachedGetterValue = promise;
			}
			return promise;
		} else if (typeof self._options.subsections === 'object') {
			return Q.all(_.map(self._options.subsections, function (value, key) {
				if (value instanceof Config) {
					return Q(value.get()).then(function (value) {
						return [key, value];
					});
				}
				return Q([key, value]);
				
			})).then(function (pairs) {
				return _.fromPairs(pairs);
			});
		}
		throw new TypeError('Config should either have a getter or subsections');
		
	},
});

module.exports = Config;

